import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getLeaSpeakerData, sendLeaSpeakerCommand, setSelectedMasterDevice, setLeaSpeakerData, setSpeakerInZone } from '../../../../action/roomControlAction'
import { closeOrderPopUp } from '../../../action/hCommerce2'
import SelectDropdown from '../../../UI/SelectDropdown'
import RoundSlider from '../roundSlider'
import { CMSPath } from '../../../../config/constant'

function SpeakerControl2(props) {
    const [selectedMasterDevice, setSelectedMasterDevice] = useState(null)
    const [currentVolume, setCurrentVolume] = useState(props.selectedSpeaker.volume)
    const [showSources, setShowSources] = useState(false)
    const [firstLaunch, setFirstLaunch] = useState(true)
    const [speakerMute, setSpeakerMute] = useState(props.selectedSpeaker.speakerMute)
    let locationId = localStorage.getItem("roomID");
    let zoneSlave = props.selectedSpeaker.identifierKey

    const checkIfMasterSelected = () => {
        console.log("selectedMasterDevice", selectedMasterDevice);
        return true
        // if(selectedMasterDevice){
        //     return true
        // } else {
        //     props.closeOrderPopUp(true, "Please select a TV source", "", true)
        //     return false
        // }
    }

    const sendSpeakerCommand = (action, masterDevice, command) => {
        let identifierKey = masterDevice ? masterDevice.identifierKey : props.selectedMasterDevice ? props.selectedMasterDevice.identifierKey : ""
        let label = masterDevice ? masterDevice.label : props.selectedMasterDevice.label
        let slaveList

        if(command == "removeFromZone"){
            if(props.speakerInZone[label]){
                slaveList = props.speakerInZone[label]
                props.speakerInZone[label].indexOf(props.selectedSpeaker.identifierKey) > 0 && slaveList.splice(props.speakerInZone[label].indexOf(props.selectedSpeaker.identifierKey), 1)
            }
            else slaveList = [zoneSlave]
        } else {
            slaveList = props.speakerInZone[label] ? props.speakerInZone[label] : [zoneSlave]
        }

        console.log("props.speakerInZone[label]",props.speakerInZone);

        if(checkIfMasterSelected())
        props.sendLeaSpeakerCommand(action, locationId, identifierKey, 
            slaveList, (status, message) => {
                if(status) updateProps(action, command, masterDevice)
                else closeOrderPopUp(true, message, "", true)
            })
    }

    const incrementDecrementVolume = (action, masterDevice, command) => {
        let identifierKey = masterDevice ? masterDevice.identifierKey : props.selectedMasterDevice ? props.selectedMasterDevice.identifierKey : ""
        if(action == "increaseSpeakerVolume") setCurrentVolume(currentVolume+1)
        else setCurrentVolume(currentVolume-1)
        props.sendLeaSpeakerCommand(action, locationId, "", [zoneSlave], (status, message) => {
            if(status) updateProps(action)
            else closeOrderPopUp(true, message, "", true)
        })
    }

    const muteSpeaker = (action, masterDevice, command) => {
        let identifierKey = masterDevice ? masterDevice.identifierKey : props.selectedMasterDevice ? props.selectedMasterDevice.identifierKey : ""
        props.sendLeaSpeakerCommand("MUTE", locationId, "", [zoneSlave], (status, message) => {
            if(status) updateProps("MUTE")
            else closeOrderPopUp(true, message, "", true)
        })
    }

    const updateProps = (action, command, tempSelectedMasterDevice) => {
        let slaveList = props.speakerList
        let zones = props.zonesInfoList
        if(action == "changeSpeakerVolume" || action == "increaseSpeakerVolume" || action == "decreaseSpeakerVolume"){
            slaveList.map((slave, index) => {
                if(slave.identifierKey == props.selectedSpeaker.identifierKey){
                    slaveList[index] = {...slaveList[index], volume: action == "increaseSpeakerVolume" ? currentVolume  + 1 : currentVolume  - 1}
                    props.setLeaSpeakerData({...props.leaSpeakerData, slavedevicesList: slaveList})
                }
            })
        } else if(action == "MUTE"){
            setSpeakerMute(!speakerMute)
            slaveList.map((slave, index) => {
                if(slave.identifierKey == props.selectedSpeaker.identifierKey){
                    slaveList[index] = {...slaveList[index], speakerMute: !props.selectedSpeaker.speakerMute}
                    props.setLeaSpeakerData({...props.leaSpeakerData, slavedevicesList: slaveList})
                }
            })
        } else if(action == "setZone"){

            let tempZone, tempSlaves, index
            zones.map((zone, ind) => {
                if(command == "removeFromZone"){
                    // remove from global prop
                    if(zone.zoneSlaves.length > 0){
                        zone.zoneSlaves.map(slave => {
                            if(slave.identifierKey == props.selectedSpeaker.identifierKey){
                                tempZone = zone
                                tempSlaves = tempZone.zoneSlaves
                                index = tempSlaves.findIndex(x => x.label === slave.label);
                                if(index >= 0){
                                    tempSlaves.splice(index, 1)
                                    tempZone["zoneSlaves"] = tempSlaves
                                    zones[ind] = tempZone
                                }
                            }
                        })
                    }
                    setLeaSpeakerData({...props.leaSpeakerData, zonesInfoList: [...zones]})
                } else {
                    // add to global prop
                    let currentSlaves = zone.zoneSlaves
                    console.log("tempZone", currentSlaves, zone.zoneSlaves, zones, zone.zoneMaster, tempSelectedMasterDevice.identifierKey)
                    if(zone.zoneMaster == tempSelectedMasterDevice.identifierKey){
                        let zoneAtCurrentIndex
                        currentSlaves.push(props.selectedSpeaker)
                        zoneAtCurrentIndex = zones[ind]
                        zoneAtCurrentIndex["zoneSlaves"] = currentSlaves
                        zones[ind] = zoneAtCurrentIndex
                    }
                    setLeaSpeakerData({...props.leaSpeakerData, zonesInfoList: [...zones]})
                }
            })  
        }
    }

    useEffect(() => {
        if(props.selectedSpeaker){
            props.zonesInfoList.map((zone) => {
                zone.zoneSlaves.map(slave => {
                    if(slave.identifierKey == props.selectedSpeaker.identifierKey){
                        setSelectedMasterDevice(zone)
                        props.setSelectedMasterDevice(zone)
                    }
                })
            })        
            setFirstLaunch(false)
        }
    }, [])

    // useEffect(() => {
    //     if(props.selectedMasterDevice && !firstLaunch)
    //     props.sendLeaSpeakerCommand("changeSpeakerVolume", locationId, "", [props.selectedSpeaker.identifierKey], () => {
    //         updateProps("changeSpeakerVolume")
    //     }, currentVolume) //props.selectedMasterDevice.identifierKey

    // }, [currentVolume])
    

  return (
    <div class="main-container background-overlay">
		<header class="inner-pages subpages">
			<a onClick={props.goBack} class="button-back"></a>
			<div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
				{/* <p class="bold" style={{color: "#fff"}}>{props.selectedSpeaker.label}</p> */}
			</div>
		</header>
		<section id="speakerControls" class="widgets padding-left-0 padding-right-0 padding-bottom-0 margin-0 container-bg">

            <div class="widget-header widget-header-checkin">
                { props.currentWidget.widgetHeaderImageUrl && 
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidget.widgetHeaderImageUrl}`} alt={props.currentWidget.displayName} />
                    </div>
                }
                <div class="widget-header-title">{props.currentWidget.displayName}</div>
            </div>

			<div class="widgets">
                <div id="spControls" class="row padding-top-0 padding-bottom-1 padding-right-1 padding-left-1 ch-controls">
					<div class="col ch-buttons ch-vertical">
						<div class="button-container">
							<button disabled={currentVolume <= 0 || !selectedMasterDevice} onClick={() => incrementDecrementVolume("decreaseSpeakerVolume")}><i class="fas fa-minus"></i></button>
						</div>
					</div>
					<div class="col ch-buttons ch-circle">
						<input disabled type="number" id="volumeValue" name="volumeValue" class="speaker-volume speaker" value={currentVolume}/>
						<button className="mute" disabled={!selectedMasterDevice}>
							<i class={`fas ${ speakerMute ? "fa-volume-mute" : "fa-volume-up"}`}  onClick={() => muteSpeaker("MUTE")}></i>
							<i class="fas fa-volume-up" style={{display: "none"}}></i>
						</button>
					</div>
					<div class="col ch-buttons ch-vertical">
						<div class="button-container">
							<button disabled={currentVolume >= 80 || !selectedMasterDevice} onClick={() => incrementDecrementVolume("increaseSpeakerVolume")}><i class="fas fa-plus"></i></button>
						</div>
					</div>
				</div>
        
				<div class="row evenrow padding-top-1 padding-bottom-1 padding-left-2 padding-right-2">
					<div class="col">
						<div class="form-controls radio-controls no-border">
                            <label>Source</label>
                            <SelectDropdown
                                selectLabel="Select source" 
                                selectKey="obj.label"
                                selectedItem={selectedMasterDevice && selectedMasterDevice.label}
                                listData={selectedMasterDevice != null ? [ {label: "Remove Source"}, ...props.masterDevicesList] : props.masterDevicesList}
                                showList={showSources}
                                setShowList={() => {
                                    setShowSources(!showSources)
                                }}
                                setSelectedItem={(obj) => {
                                    setShowSources(false)
                                    if(obj.label == "Remove Source"){
                                        let speakerInZone = props.speakerInZone
                                        if(speakerInZone[props.selectedMasterDevice.label].indexOf(props.selectedSpeaker.identifierKey)){
                                            speakerInZone[props.selectedMasterDevice.label].splice(speakerInZone[props.selectedMasterDevice.label].indexOf(props.selectedSpeaker.identifierKey), 1)
                                        }
                                        setSpeakerInZone(speakerInZone)
                                        sendSpeakerCommand("setZone", null, "removeFromZone")
                                        setSelectedMasterDevice(null)
                                        props.setSelectedMasterDevice(null)
                                    } else {
                                        setSelectedMasterDevice(obj)
                                        let speakerInZone = props.speakerInZone
                                        if(!speakerInZone[obj.label] || speakerInZone[obj.label].length == 0){
                                            speakerInZone[obj.label] = [props.selectedSpeaker.identifierKey]
                                        } else {
                                            if(speakerInZone[obj.label] && !speakerInZone[obj.label].includes(props.selectedSpeaker.identifierKey)){
                                                speakerInZone[obj.label].push(props.selectedSpeaker.identifierKey)
                                            }
                                        }
                                        console.log("speakerInZone", speakerInZone)
                                        setSpeakerInZone(speakerInZone)
                                        props.setSelectedMasterDevice(obj)
                                        sendSpeakerCommand("setZone", obj)
                                    }
                                }}
                            />
						</div>
					</div>
				</div>

			</div>
		</section>
    </div>
  )
}

const mapStateToProps = (state) => {
	return {
		masterDevicesList: state.store.leaSpeakerData.masterDevicesList,
		zonesInfoList: state.store.leaSpeakerData.zonesInfoList,
        speakerList: state.store.leaSpeakerData.slavedevicesList,
        leaSpeakerData: state.store.leaSpeakerData,
        selectedMasterDevice: state.store.selectedMasterDevice,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
		currentWidget: state.store.sideNavBar.currentWidget,
        speakerInZone: state.store.speakerInZone
	}
}

const mapDispatchToProps = dispatch => {
	return bindActionCreators({sendLeaSpeakerCommand, getLeaSpeakerData, closeOrderPopUp, setSelectedMasterDevice, setLeaSpeakerData, setSpeakerInZone}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SpeakerControl2);



{/* <button onClick={() => sendSpeakerCommand("MUTE")}>{/* speakerMute *
                    <i class="fas fa-volume-mute"></i>
                </button>
				<div id="tempToggle" class="row padding-bottom-1 padding-right-1 padding-left-1">
					<div class="col col-2">
                    <RoundSlider
                        radius="80"
                        circleShape="pie"
                        sliderType="min-range"
                        change={(e) => setCurrentVolume(e.value)}
                        startAngle={315}
                        value={currentVolume}
                        disabled
                        handleSize="+1"
                        min={0}
                        max={80}
                    />
						<div class="frame slider-icons">
							<div id="slider" class="rslider"></div>
							<div class="thermostat">
								<div class="ring">
									<div class="bottom_overlay"></div>
								</div>
								<div class="control">
									<div class="temp_room"><span></span></div>
								</div>
							</div>
							<div class="slider-icons-set">
								<span><i class="fas fa-volume-off"></i></span>
								<span><i class="fas fa-volume-up"></i></span>
							</div>
						</div>
					</div>
				</div> */}